/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("InitService", function (context, cls) {
  /**
   * Root Service
   * @namespace gbc.InitService
   * @gbcService
   */
  class InitService /** @lends gbc.InitService */ {
    constructor() {
      this._builtinActionDefaultsKeys = [
        "enter",
        "esc",
        "f3",
        "ctrl+f3",
        "f4",
        "f1",
        "alt+f4",
        "ctrl+f",
        "ctrl+g",
        "tab",
        "shift+tab",
        "down",
        "up",
        "home",
        "end",
        "pageup",
        "pagedown",
        "ctrl+tab",
        "ctrl+shift+tab"
      ];

      this._services = [];
      this._onVisibilityChangeHandler = null;
      this._eventListener = new cls.EventListener();
      /**
       * unique identifiers increments storage
       */
      this._uniqueId = {
        asString: 0,
        asNumber: 0
      };
    }

    create(auiData, app, forUnit) {
      app = app || context.MockService.fakeApplication(forUnit);
      const treeModificationTrack = new cls.TreeModificationTracker();
      const node = gbc.classes.NodeFactory.createRecursive(null, auiData, app, treeModificationTrack);
      node.createController();
      return node;
    }

    register(service) {
      this._services.push(service);
    }

    initServices() {
      this._onVisibilityChangeHandler = function () {
        this.emit(context.constants.widgetEvents.visibilityChange);
      }.bind(this);
      document.addEventListener("visibilitychange", this._onVisibilityChangeHandler);

      for (const service of this._services) {
        service.init();
      }
      context.__wrapper.emit(context.__wrapper.events.SERVICESREADY);
    }

    destroy() {
      document.removeEventListener("visibilitychange", this._onVisibilityChangeHandler);
      if (context.SessionService.getCurrent()) {
        const currentApp = context.SessionService.getCurrent().getCurrentApplication();
        if (currentApp) {
          currentApp.close();
        }
      }
    }

    /**
     * Get a unique identifier (an auto increment number)
     * @return {number}
     */
    uniqueId() {
      return ++this._uniqueId.asNumber;
    }

    /**
     * Get a unique identifier as string (based on an auto increment number)
     * @return {string} a unique identifier as string
     */
    uniqueIdAsString() {
      return `${++this._uniqueId.asString}`;
    }

    emit(eventName) {
      this._eventListener.emit(eventName);
    }
    when(eventName, hook) {
      return this._eventListener.when(eventName, hook);
    }
  }

  gbc.InitService = new InitService();
});
